var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("description-container", {
    scopedSlots: _vm._u(
      [
        {
          key: "header",
          fn: function () {
            return [_c("description-heading", [_vm._v(_vm._s(_vm.title))])]
          },
          proxy: true,
        },
        {
          key: "body",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "text-sm px-4 pt-3 pb-12" },
                [_vm._t("default")],
                2
              ),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }